import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon45: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 14.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 14 20" width={width} height={height} {...props}>
      <Path
        d="M1.953 1.94614C4.559 -0.648863 8.781 -0.648887 11.386 1.94711C13.958 4.51011 13.928 8.61913 11.399 11.3331C11.324 11.4131 11.247 11.4891 11.163 11.5621C11.04 11.6711 11.1 11.6241 10.721 11.9121C10.142 12.3511 9.974 12.6921 9.974 13.9131V14.1831C10.69 14.5131 11.187 15.2351 11.187 16.0731V17.9182C11.187 19.0682 10.251 20.0001 9.098 20.0001H4.261C3.107 20.0001 2.17099 19.0682 2.17099 17.9182V16.0731C2.17099 15.2431 2.659 14.5261 3.365 14.1921L3.36599 13.9131C3.36599 12.6921 3.198 12.3511 2.619 11.9121C2.24 11.6241 2.3 11.6711 2.177 11.5621C2.093 11.4891 2.015 11.4131 1.953 11.3471C-0.651 8.75111 -0.651 4.54214 1.953 1.94614ZM9.098 14.9881H4.261C3.659 14.9881 3.17099 15.4741 3.17099 16.0731V17.9182C3.17099 18.5182 3.659 19.0031 4.261 19.0031H9.098C9.699 19.0031 10.187 18.5182 10.187 17.9182V16.0731C10.187 15.4741 9.699 14.9881 9.098 14.9881ZM10.679 2.65112C8.465 0.445123 4.875 0.445123 2.66 2.65112C0.447001 4.85712 0.446994 8.43612 2.67299 10.6551C2.72399 10.7101 2.77899 10.7621 2.83799 10.8151C2.93399 10.8991 2.879 10.8571 3.225 11.1191C4.053 11.7471 4.36599 12.3821 4.36599 13.9131L4.365 13.9911H6.17L6.17099 10.1391L4.559 7.46112C4.417 7.22612 4.493 6.91914 4.73 6.77814C4.967 6.63614 5.274 6.71313 5.416 6.94913L6.67 9.03012L7.924 6.94913C8.05 6.73913 8.307 6.65514 8.529 6.73914L8.61 6.77814C8.847 6.91914 8.924 7.22612 8.781 7.46112L7.17 10.1361V13.9911H8.973L8.974 13.9131C8.974 12.4671 9.253 11.8201 9.982 11.2241L10.115 11.1191C10.46 10.8571 10.406 10.8991 10.501 10.8151C10.561 10.7621 10.615 10.7101 10.667 10.6551C12.837 8.32612 12.863 4.82712 10.679 2.65112Z"
        fill="#FFD147"
      />
    </Icon>
  )
}
